export const MESSAGES = {
  selfCrossing: 'The stroke crosses itself. Draw it without loops.',
  multiPartLine:
    'Line slices need a single-part annotation. Use the lasso to separate an island first.',
  encloseOne: 'Enclose one whole island.',
  endsInside: 'The line must start and end outside the annotation.',
  noDivide: "The line doesn't divide the annotation.",
  lassoNoTouch: "The lasso doesn't touch the annotation.",
  coversAll: 'The lasso covers the whole annotation. To relabel it, change its class.',
  cutsMany: (pieces: number): string =>
    `The line cuts ${pieces} pieces. A slice must make exactly two.`,
  separatePieces: 'The lasso would leave separate pieces. Slice them one at a time.',
  maskLimit: 'This image already has the maximum of 255 masks.',
  failed: 'Slice failed, nothing was changed.',
  geometryFailed: "This cut couldn't be computed. Try a slightly different stroke.",
  targetChanged: 'The annotation changed while you were slicing. Draw the slice again.',
} as const

export const SLICE_HINT = 'DRAW A LINE OR A LASSO TO SLICE · ESC TO CANCEL'
